import { Dispatch, SetStateAction, createContext } from "react";
import { User, UserSummary } from "../../models";
import { Any } from "../../test-helpers/Any";

export type IProfileContext = {
    currentUser?: User;
    impersonator?: User;
    userSummary?: UserSummary;
    userIsLoading: boolean;
    setImpersonator: Dispatch<SetStateAction<User | undefined>>;
};

const defaultValue: IProfileContext = {
    setImpersonator: Any.voidFn,
    userIsLoading: false,
};

export const ProfileContext = createContext<IProfileContext>(defaultValue);
ProfileContext.displayName = "Profile";
